<template>
    <div class="base-info">
        <div>
            <div class="shadow">
                <div style="display: flex;align-items: flex-end;">
                    <span class="d-title">基本信息</span>
                    <span style="flex: 1;text-align: right;" class="d-edit" @click="isEdit = !isEdit">编辑</span>
                </div>
                <div style="margin-top: 0.2rem;">
                    <div style="background-color: #909399;height: 1px;width: 100%;"></div>
                </div>
                <div style="margin-top: 0.2rem;" id="b-content">
                    <div v-if="!isEdit" style="padding: 0.1rem 0 0.1rem 0;">
                        <el-row type="flex" justify="space-between">
                            <el-col :span="4" class="col">姓名:</el-col>
                            <el-col :span="8" class="col-n col over-title" :title="baseInfoForm.username">{{
                                baseInfoForm.username }}</el-col>
                            <el-col :span="4" class="col">邮箱:</el-col>
                            <el-col :span="8" class="col-n col">{{ baseInfoForm.email }}</el-col>
                        </el-row>
                        <el-row type="flex" justify="space-between">
                            <el-col :span="4" class="col">部门:</el-col>
                            <el-col :span="8" class="col-n col">{{ base.branch }}</el-col>
                            <el-col :span="4" class="col">主部门:</el-col>
                            <el-col :span="8" class="col-n col"></el-col>
                        </el-row>
                        <el-row type="flex" justify="space-between">
                            <el-col :span="4" class="col">直属主管:</el-col>
                            <el-col :span="8" class="col-n col">{{ base.direct_leader }}</el-col>
                            <el-col :span="4" class="col">职位:</el-col>
                            <el-col :span="8" class="col-n col">{{ baseInfoForm.position }}</el-col>
                        </el-row>
                        <el-row type="flex" justify="space-between">
                            <el-col :span="4" class="col">手机号:</el-col>
                            <el-col :span="8" class="col-n col">{{ baseInfoForm.phone }}</el-col>
                            <el-col :span="4" class="col">工号:</el-col>
                            <el-col :span="8" class="col-n col">{{ baseInfoForm.job_number }}</el-col>
                        </el-row>
                        <el-row type="flex" justify="space-between">
                            <el-col :span="4" class="col">分机号:</el-col>
                            <el-col :span="8" class="col-n col">{{ baseInfoForm.phone_ext }}</el-col>
                            <el-col :span="4" class="col">办公地点:</el-col>
                            <el-col :span="8" class="col-n col" v-if="baseInfoForm.work_place === 1">静安</el-col>
                            <el-col :span="8" class="col-n col" v-else-if="baseInfoForm.work_place === 2">奉贤</el-col>
                            <el-col :span="8" class="col-n col" v-else></el-col>
                        </el-row>
                        <el-row type="flex" justify="space-between">
                            <el-col :span="4" class="col">备注:</el-col>
                            <el-col :span="8" class="col-n col">{{ baseInfoForm.notes }}</el-col>
                            <el-col :span="4" class="col">入职时间:</el-col>
                            <el-col :span="8" class="col-n col">{{ baseInfoForm.joined_at }}</el-col>
                        </el-row>
                        <el-row type="flex" justify="space-between">
                            <el-tooltip effect="dark" content="系统计算,系统根据「入职时间」自动计算!" placement="top">
                                <el-col :span="4" class="col over-title">司龄(系统计算):</el-col>
                            </el-tooltip>
                            <el-col :span="8" class="col-n col over-title" :title="seniority">{{ seniority }}</el-col>
                            <el-col :span="4" class="col"></el-col>
                            <el-col :span="8" class="col-n col"></el-col>
                        </el-row>
                    </div>
                    <div v-else>
                        <el-form ref="baseInfoForm" :model="baseInfoForm" label-width="100px" size="medium">
                            <el-form-item label="姓名">
                                <el-input v-model.trim="baseInfoForm.username" clearable></el-input>
                            </el-form-item>
                            <el-form-item label="邮箱">
                                <el-input v-model.trim="baseInfoForm.email" clearable></el-input>
                            </el-form-item>
                            <el-form-item label="部门">
                                <el-select v-model="baseInfoForm.branch_id" placeholder="请选择" @click.native="loadBranch"
                                    style="width: 100%" clearable filterable size="medium">
                                    <el-option v-for="item in BranchOptions" :key="item.id" :label="item.name"
                                        :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="主部门">
                                <el-select v-model="baseInfoForm.branch_id_main" placeholder="请选择" @click.native=""
                                    style="width: 100%" clearable filterable size="medium">
                                    <el-option v-for="item in BranchMainOptions" :key="item.id" :label="item.name"
                                        :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="直属主管">
                                <el-select v-model="baseInfoForm.leader_direct" placeholder="请选择"
                                    @click.native="ysyMGetAdminUser" style="width: 100%" clearable filterable size="medium">
                                    <el-option v-for="item in ysyMGetAdminUserOptions" :key="item.id" :label="item.username"
                                        :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="职位">
                                <el-input v-model.trim="baseInfoForm.position" clearable></el-input>
                            </el-form-item>
                            <el-form-item label="手机号">
                                <el-input v-model.trim="baseInfoForm.phone" clearable></el-input>
                            </el-form-item>
                            <el-form-item label="工号">
                                <el-input v-model.trim="baseInfoForm.job_number" clearable></el-input>
                            </el-form-item>
                            <el-form-item label="分机号">
                                <el-input v-model.trim="baseInfoForm.phone_ext" clearable></el-input>
                            </el-form-item>
                            <el-form-item label="办公地点">
                                <el-select v-model="baseInfoForm.work_place" placeholder="请选择" style="width: 100%" clearable
                                    filterable size="medium">
                                    <el-option :value="1" label="静安">
                                        静安
                                    </el-option>
                                    <el-option :value="2" label="奉贤">
                                        奉贤
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="备注">
                                <el-input type="textarea" v-model.trim="baseInfoForm.notes" :rows=1></el-input>
                            </el-form-item>
                            <el-form-item label="入职时间">
                                <el-date-picker v-model="baseInfoForm.joined_at" type="date" unlink-panels
                                    value-format="yyyy-MM-dd" style="width: 100%" size="medium">
                                </el-date-picker>
                            </el-form-item>
                            <!-- <el-form-item label="司龄">
                                <el-input v-model.trim="seniority" clearable readonly></el-input>
                            </el-form-item> -->
                            <el-form-item size="medium">
                                <el-button type="primary" @click="onSubmit">提交</el-button>
                                <el-button @click.native="isEdit = !isEdit">取消</el-button>
                            </el-form-item>
                        </el-form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { common } from '../../../../static/mixins/common'
export default {
    name: 'BaseInfo',
    mixins: [common],
    props: {
        adminuser_id: {
            type: Number
        },
        adminuser_name: {
            type: String
        }
    },
    data() {
        return {
            baseInfoForm: {
                username: '',
                email: '',
                branch_id: '',
                branch_id_main: '',
                leader_direct: '',
                position: '',
                phone: '',
                job_number: '',
                phone_ext: '',
                work_place: '',
                notes: '',
                joined_at: ''
            },
            base: {
                branch: '',
                direct_leader: '',
            },
            seniority: '',
            isEdit: false,
            BranchOptions: [],
            BranchMainOptions: [],
            adminuserId: '',
            adminuserName: ''
        }
    },
    methods: {
        onSubmit() {
            this.baseInfoForm.admin_user_id = this.adminuserId
            this.$axios.put('api/api3_update_baseinfo', this.baseInfoForm).then(({ data }) => {
                if (data.code === 200) {
                    this.$message.success(data.msg)
                } else {
                    this.$message.error(data.msg)
                }
            }).catch()
        },
        loadBranch() {
            this.$axios.get('api/api3_get_branch').then(({ data }) => {
                if (data.code === 200) {
                    this.BranchOptions = data.data
                } else {
                    this.$message.error(data.msg)
                }
            }).catch()
        },
        getAdminUserInfo(admin_user_id) {
            this.resetForm()
            this.BranchOptions = []
            this.loadBranch()
            this.ysyMGetAdminUserOptions = []
            this.ysyMGetAdminUser()
            this.ysyMGetAdminUserInfo(admin_user_id)
        },
        resetForm() {
            this.baseInfoForm.username = ''
            this.baseInfoForm.email = ''
            this.baseInfoForm.branch_id = ''
            this.baseInfoForm.branch_id_main = ''
            this.baseInfoForm.leader_direct = ''
            this.baseInfoForm.position = ''
            this.baseInfoForm.phone = ''
            this.baseInfoForm.job_number = ''
            this.baseInfoForm.phone_ext = ''
            this.baseInfoForm.work_place = ''
            this.baseInfoForm.notes = ''
            this.baseInfoForm.joined_at = ''

            this.base.branch = ''
            this.base.direct_leader = ''

            this.seniority = ''
        },
    },
    watch: {
        adminuser_id: {
            immediate: true,
            handler(n, o) {
                this.adminuserId = null
                if (n !== o) {
                    this.adminuserId = n
                    this.getAdminUserInfo(n)
                }
            }
        },
        adminuser_name: {
            immediate: true,
            handler(n, o) {
                if (n !== o) {
                    this.adminuserName = n
                }
            }
        },
        ysyMAdminUserInfoOptions: {
            handler(n, o) {
                if (n !== o) {
                    if (n) {
                        this.baseInfoForm.username = n.username
                        this.baseInfoForm.email = n.email
                        this.baseInfoForm.branch_id = n.branch_id ? n.branch_id : ''
                        this.base.branch = n.branch ? n.branch.name : ''
                        this.baseInfoForm.position = n.position
                        this.baseInfoForm.phone = n.phone
                        this.baseInfoForm.job_number = n.job_number
                        if (n.admin_user_annex) {
                            this.baseInfoForm.phone_ext = n.admin_user_annex.phone_ext
                            this.baseInfoForm.work_place = n.admin_user_annex.work_place
                            this.baseInfoForm.notes = n.admin_user_annex.notes
                            this.baseInfoForm.joined_at = n.admin_user_annex.joined_at
                            this.seniority = n.admin_user_annex.seniority
                            if (n.admin_user_annex.direct_leader) {
                                this.baseInfoForm.leader_direct = n.admin_user_annex.direct_leader.id
                                this.base.direct_leader = n.admin_user_annex.direct_leader.username
                            }
                        }
                    }
                }
            },
        },
    }
}
</script>

<style scoped>
.d-title {
    font-size: x-large;
    font-weight: bold;
}

.d-edit {
    font-size: medium;
    font-weight: bold;
    color: #409EFF;
    cursor: pointer;
}

/* .col {
    font-size: larger;
    font-weight: bold;
} */

/* .col-n {
    color: slategrey;
} */

#b-content .el-row {
    margin-bottom: 0.6rem;
}

.shadow {
    padding: 0.3rem 0.6rem;
    border: 1px solid #ccc;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, .3);
    margin: 0.2rem;
}

.over-title {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

#b-content>>>.el-form-item {
    width: 45% !important;
    display: inline-block !important;
}
</style>


// WEBPACK FOOTER //
// src/pages/authority/UserInfoTab/BaseInfo.vue